// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.settingsButton .p-button-label {
  font-weight: 700 !important;
}

.truncate-text {
  width: 100%;
  max-width: 65vw;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  /* Large devices (desktops, 992px and up) */
}
@media only screen and (min-width: 601px) {
  .truncate-text {
    max-width: 75vw;
  }
}
@media only screen and (min-width: 992px) {
  .truncate-text {
    max-width: 60vw;
  }
}

.truncate-span {
  display: block;
  max-width: 30vw;
}

.industry-input-disabled {
  opacity: 0.6;
}

:host ::ng-deep .p-dropdown-panel {
  max-height: 300px;
  overflow: hidden;
}
:host ::ng-deep .p-dropdown-panel .p-dropdown-items-wrapper {
  overflow-y: auto;
  max-height: 300px;
  padding: 0;
  margin: 0;
}
:host ::ng-deep .p-dropdown-panel .p-dropdown-items-wrapper::-webkit-scrollbar {
  width: 6px;
}
:host ::ng-deep .p-dropdown-panel .p-dropdown-items-wrapper::-webkit-scrollbar-track {
  background: #f1f1f1;
}
:host ::ng-deep .p-dropdown-panel .p-dropdown-items-wrapper::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 3px;
}
:host ::ng-deep .p-dropdown-panel .p-dropdown-items {
  padding: 0;
  margin: 0;
}
:host ::ng-deep .p-dropdown-panel .p-dropdown-items .p-dropdown-item {
  padding: 0.5rem 1rem;
  margin: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
:host ::ng-deep .p-dropdown-panel .p-dropdown-item-group {
  padding: 0.5rem 1rem;
  margin: 0;
  font-weight: 600;
  background: var(--surface-b);
  position: sticky;
  top: 0;
  z-index: 1;
}
:host ::ng-deep .p-dropdown {
  width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/app/main/apps/components/settings-form/settings-form-organization/settings-form-organization.component.scss"],"names":[],"mappings":"AACI;EACI,2BAAA;AAAR;;AAIA;EACI,WAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EAMA,2CAAA;AANJ;AAEI;EAPJ;IAQQ,eAAA;EACN;AACF;AAEI;EAZJ;IAaQ,eAAA;EACN;AACF;;AAEA;EACI,cAAA;EACA,eAAA;AACJ;;AAEA;EACI,YAAA;AACJ;;AAGI;EACI,iBAAA;EACA,gBAAA;AAAR;AAEQ;EACI,gBAAA;EACA,iBAAA;EACA,UAAA;EACA,SAAA;AAAZ;AAEY;EACI,UAAA;AAAhB;AAGY;EACI,mBAAA;AADhB;AAIY;EACI,gBAAA;EACA,kBAAA;AAFhB;AAMQ;EACI,UAAA;EACA,SAAA;AAJZ;AAMY;EACI,oBAAA;EACA,SAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAJhB;AAQQ;EACI,oBAAA;EACA,SAAA;EACA,gBAAA;EACA,4BAAA;EACA,gBAAA;EACA,MAAA;EACA,UAAA;AANZ;AAUI;EACI,WAAA;AARR","sourcesContent":[".settingsButton {\n    .p-button-label {\n        font-weight: 700 !important;\n    }\n}\n\n.truncate-text {\n    width: 100%;\n    max-width: 65vw;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n\n    @media only screen and (min-width: 601px) {\n        max-width: 75vw;\n    }\n\n    /* Large devices (desktops, 992px and up) */\n    @media only screen and (min-width: 992px) {\n        max-width: 60vw;\n    }\n}\n\n.truncate-span {\n    display: block;\n    max-width: 30vw;\n}\n\n.industry-input-disabled {\n    opacity: 0.6;\n}\n\n:host ::ng-deep {\n    .p-dropdown-panel {\n        max-height: 300px;\n        overflow: hidden;\n\n        .p-dropdown-items-wrapper {\n            overflow-y: auto;\n            max-height: 300px;\n            padding: 0;\n            margin: 0;\n\n            &::-webkit-scrollbar {\n                width: 6px;\n            }\n\n            &::-webkit-scrollbar-track {\n                background: #f1f1f1;\n            }\n\n            &::-webkit-scrollbar-thumb {\n                background: #888;\n                border-radius: 3px;\n            }\n        }\n\n        .p-dropdown-items {\n            padding: 0;\n            margin: 0;\n\n            .p-dropdown-item {\n                padding: 0.5rem 1rem;\n                margin: 0;\n                white-space: nowrap;\n                overflow: hidden;\n                text-overflow: ellipsis;\n            }\n        }\n\n        .p-dropdown-item-group {\n            padding: 0.5rem 1rem;\n            margin: 0;\n            font-weight: 600;\n            background: var(--surface-b);\n            position: sticky;\n            top: 0;\n            z-index: 1;\n        }\n    }\n\n    .p-dropdown {\n        width: 100%;\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
